import { ArrowRight, ArrowUpAll } from "../../assets/images";
const productsHospital = [
  {
    id: 0,
    name: "Entrar",
    environmentArea: 0,
    category: { image: ArrowRight },
    pinPos: [104.90330051778398, 224.54399236796877, -89.77355142224744],
    boardPos: [-48, 78, 0],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 342.535544163025,
        y: 187.50210884677762,
        z: -115.37303428762846,
      },
      target: {
        x: 342.5777632984701,
        y: 187.48858837967535,
        z: -114.37401740009771,
      },
      posMobile: {
        x: 342.535544163025,
        y: 187.50210884677762,
        z: -115.37303428762846,
      },
      targetMobile: {
        x: 342.5777632984701,
        y: 187.48858837967535,
        z: -114.37401740009771,
      },
    },
    cameraOut: {
      pos: {
        x: 74.25036759688784,
        y: 230.6801244500861,
        z: 174.96815084818667,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: -1,
    name: "Sair",
    environmentArea: 0,
    category: { image: ArrowUpAll },
    pinPos: [205.72315001040445, 206, -94.90747498001951],
    boardPos: [-48, 78, 0],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 66.84358145103943,
        y: 233.6811344867689,
        z: 157.0332234581075,
      },
      target: {
        x: 65.87810874024639,
        y: 233.58089828382273,
        z: 157.27367126602616,
      },
      posMobile: {
        x: 66.84358145103943,
        y: 233.6811344867689,
        z: 157.0332234581075,
      },
      targetMobile: {
        x: 65.87810874024639,
        y: 233.58089828382273,
        z: 157.27367126602616,
      },
    },
    cameraOut: {
      pos: {
        x: 74.25036759688784,
        y: 230.6801244500861,
        z: 174.96815084818667,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 20,
    pinPos: [-391.0469729473649, 366.7792764391072, 168.6834799722831],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -300.12697950796013,
        y: 299.6513196311759,
        z: 145.73407015398288,
      },
      target: {
        x: -300.8759296132175,
        y: 300.2223510138289,
        z: 146.070220269051,
      },
      posMobile: {
        x: -300.12697950796013,
        y: 299.6513196311759,
        z: 145.73407015398288,
      },
      targetMobile: {
        x: -300.8759296132175,
        y: 300.2223510138289,
        z: 146.070220269051,
      },
    },
    cameraOut: {
      pos: {
        x: 66.83131479345467,
        y: 233.74808870201934,
        z: 157.02178719707712,
      },
      target: {
        x: 65.87810874024639,
        y: 233.58089828382273,
        z: 157.27367126602616,
      },
    },
  },
  {
    id: 21,
    environmentArea: 0,
    pinPos: [202.45775505181678, 186.46521733495086, 205.34791551761552],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 269.3219656516904,
        y: 230.81330810572447,
        z: 88.8433242919284,
      },
      target: {
        x: 269.0072741218614,
        y: 230.48428863870822,
        z: 89.73366997276155,
      },
      posMobile: {
        x: 269.3219656516904,
        y: 230.81330810572447,
        z: 88.8433242919284,
      },
      targetMobile: {
        x: 269.0072741218614,
        y: 230.48428863870822,
        z: 89.73366997276155,
      },
    },
    cameraOut: {
      pos: {
        x: 342.5408142900664,
        y: 187.50430476621312,
        z: -115.37321095790931,
      },
      target: {
        x: 342.5777632984701,
        y: 187.48858837967535,
        z: -114.37401740009771,
      },
    },
  },
  {
    id: 22,
    pinPos: [450.1918013668572, 200.0591198956608, 509.0326057331358],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 264.0643370149332,
        y: 248.02945842369826,
        z: 231.30875044728984,
      },
      target: {
        x: 264.7730133482364,
        y: 247.86508969026264,
        z: 231.99487053450827,
      },
      posMobile: {
        x: 264.0643370149332,
        y: 248.02945842369826,
        z: 231.30875044728984,
      },
      targetMobile: {
        x: 264.7730133482364,
        y: 247.86508969026264,
        z: 231.99487053450827,
      },
    },
    cameraOut: {
      pos: {
        x: 342.5408142900664,
        y: 187.50430476621312,
        z: -115.37321095790931,
      },
      target: {
        x: 342.5777632984701,
        y: 187.48858837967535,
        z: -114.37401740009771,
      },
    },
  },
  {
    id: 23,
    environmentArea: 0,
    pinPos: [-391.0469729473649, 366.7792764391072, 106.21962790134768],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -314.1477538274692,
        y: 295.32720594983795,
        z: 163.1679043252528,
      },
      target: {
        x: -314.8925366215847,
        y: 295.9015369911015,
        z: 162.82813610332713,
      },
      posMobile: {
        x: -314.1477538274692,
        y: 295.32720594983795,
        z: 163.1679043252528,
      },
      targetMobile: {
        x: -314.8925366215847,
        y: 295.9015369911015,
        z: 162.82813610332713,
      },
    },
    cameraOut: {
      pos: {
        x: 66.83131479345467,
        y: 233.74808870201934,
        z: 157.02178719707712,
      },
      target: {
        x: 65.87810874024639,
        y: 233.58089828382273,
        z: 157.27367126602616,
      },
    },
  },
  {
    id: 24,
    pinPos: [-221.15370923289464, 21.01313206455012, 474.1911165701414],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -98.70883673174457,
        y: 190.61527842362338,
        z: 364.905650492768,
      },
      target: {
        x: -99.11094046321053,
        y: 189.90044351571757,
        z: 365.477772545813,
      },
      posMobile: {
        x: -98.70883673174457,
        y: 190.61527842362338,
        z: 364.905650492768,
      },
      targetMobile: {
        x: -99.11094046321053,
        y: 189.90044351571757,
        z: 365.477772545813,
      },
    },
    cameraOut: {
      pos: {
        x: 66.83131479345467,
        y: 233.74808870201934,
        z: 157.02178719707712,
      },
      target: {
        x: 65.87810874024639,
        y: 233.58089828382273,
        z: 157.27367126602616,
      },
    },
  },
  {
    id: 25,
    pinPos: [-320.83636463705705, 372.232707019094, 482.97828055919825],
    scale: 0.8,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -202.56298063168543,
        y: 261.6079311151519,
        z: 524.4639345713097,
      },
      target: {
        x: -203.32275003948104,
        y: 262.2529360747806,
        z: 524.3819647656962,
      },
      posMobile: {
        x: -202.56298063168543,
        y: 261.6079311151519,
        z: 524.4639345713097,
      },
      targetMobile: {
        x: -203.32275003948104,
        y: 262.2529360747806,
        z: 524.3819647656962,
      },
    },
    cameraOut: {
      pos: {
        x: 66.83131479345467,
        y: 233.74808870201934,
        z: 157.02178719707712,
      },
      target: {
        x: 65.87810874024639,
        y: 233.58089828382273,
        z: 157.27367126602616,
      },
    },
  },
  {
    id: 26,
    environmentArea: 0,
    pinPos: [341.79404663094016, 363.4016670662629, 539.0062219467872],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 418.0450747171464,
        y: 282.94676210640773,
        z: 400.4889555121177,
      },
      target: {
        x: 417.78736887969916,
        y: 283.4092599495895,
        z: 401.33729709803566,
      },
      posMobile: {
        x: 418.0450747171464,
        y: 282.94676210640773,
        z: 400.4889555121177,
      },
      targetMobile: {
        x: 417.78736887969916,
        y: 283.4092599495895,
        z: 401.33729709803566,
      },
    },
    cameraOut: {
      pos: {
        x: 342.5408142900664,
        y: 187.50430476621312,
        z: -115.37321095790931,
      },
      target: {
        x: 342.5777632984701,
        y: 187.48858837967535,
        z: -114.37401740009771,
      },
    },
  },
  {
    id: 27,
    pinPos: [-493.3418672324941, 192.81860039681533, 398.12994166772575],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -170.17480568032732,
        y: 191.42965981508277,
        z: 346.172280651153,
      },
      target: {
        x: -171.11829636033286,
        y: 191.3858900974315,
        z: 346.50077653934557,
      },
      posMobile: {
        x: -170.17480568032732,
        y: 191.42965981508277,
        z: 346.172280651153,
      },
      targetMobile: {
        x: -171.11829636033286,
        y: 191.3858900974315,
        z: 346.50077653934557,
      },
    },
    cameraOut: {
      pos: {
        x: 66.83131479345467,
        y: 233.74808870201934,
        z: 157.02178719707712,
      },
      target: {
        x: 65.87810874024639,
        y: 233.58089828382273,
        z: 157.27367126602616,
      },
    },
  },
];

export default productsHospital;
